import VueRouter from 'vue-router';

let routes = [
  {
    path: '/',
    name: 'home-view',
    component: require('./views/Home.vue').default
  },
  {
    path: '/todo',
    name: 'todo-view',
    component: require('./views/Todo.vue').default
  },
  {
    path: '/about-us',
    name: 'about-us-view',
    component: require('./views/AboutUs.vue').default
  },
  {
    path: '/how-it-works',
    name: 'how-it-works-view',
    component: require('./views/HowItWorks.vue').default
  },
  {
    path: '/compare-packages',
    name: 'compare-packages-view',
    component: require('./views/ComparePackages.vue').default
  },
  {
    path: '/contact',
    name: 'contact-view',
    component: require('./views/Contact.vue').default
  },
  {
    path: '/privacy-policy',
    name: 'privacy-policy-view',
    component: require('./views/PrivacyPolicy.vue').default
  },
  {
    path: '/why-it-is-worth-it',
    name: 'why-it-is-worth-it-view',
    component: require('./views/WhyItsWorthIt.vue').default
  },
  {
    path: '/help',
    name: 'help-view',
    component: require('./views/Help.vue').default
  },
  {
    path: '/login',
    name: 'login-view',
    component: require('./views/Login.vue').default
  },
  {
    path: '/register',
    name: 'register-view',
    component: require('./views/Register.vue').default
  },
  {
    path: '/order/collection-set',
    name: 'collection-set-order-view',
    component: require('./views/CollectionSetOrder.vue').default
  },
  {
    path: '/order/analysis',
    name: 'analysis-order-view',
    component: require('./views/AnalysisOrder.vue').default
  },
  {
    path: '/account/surveys',
    name: 'account-surveys-view',
    component: require('./views/MySurveys.vue').default,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/account/surveys/:id',
    name: 'account-survey-view',
    component: require('./views/Survey.vue').default,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/account/consultations',
    name: 'account-consultations-view',
    component: require('./views/MyConsultations.vue').default,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/account',
    name: 'account-view',
    component: require('./views/MyAccount.vue').default,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/account/analysis',
    name: 'account-analysis-view',
    component: require('./views/MyAnalysis.vue').default,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/order/box-shop-entry',
    name: 'box-shop-entry',
    component: require('./views/BoxShop.vue').default
  },
  {
    path: '/why-you-should-know-your-genome',
    name: 'why-you-should-know-your-genome-view',
    component: require('./views/WhyYouShouldKnowYourGenome.vue').default
  },
  {
    path: '/faq',
    name: 'faq-view',
    component: require('./views/Faq.vue').default
  },
  {
    path: '/home-test',
    name: 'home-test-view',
    component: require('./views/Home-test.vue').default
  }

]

let router = new VueRouter({
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (to.hash) {
      return document.querySelector(to.hash);
    }

    if (savedPosition) {
      return savedPosition
    } 
    return { x: 0, y: 0 }  
  },
});

router.beforeEach((to, from, next) => {
  if(to.matched.some(record => record.meta.requiresAuth)) {
    console.log(to);
    console.log(from);
    console.log(next);

    if (localStorage.getItem('access_token') == null) {
        console.log("aaa");
        next({
            path: '/login',
            params: { nextUrl: to.fullPath }
        })
    
    } else {
      console.log("bbbb");
      next();
    }
  }
  else{
    next();
  }
});

export default router;



// WEBPACK FOOTER //
// ./src/routes.js